//src/components/playdate/PlaydateInviteResponseList.tsx
import React from "react";
import {
    PlaydateInviteResponse,
    ResponseType,
} from "../../gql/types";
import styles from "./PlaydateInviteResponseList.module.css";
import PlaydateInviteResponseUnit from "./PlaydateInviteResponseUnit";

interface PlaydateInviteResponseListProps {
    inviteResponses: PlaydateInviteResponse[];
}

const PlaydateInviteResponseList: React.FC<PlaydateInviteResponseListProps> = ({
    inviteResponses,
}) => {
    // 1. Filter out invalid responses
    const validResponses = inviteResponses.filter(response =>
        response &&
        response.guest &&
        response.responseType &&
        response.updatedAt &&
        response.inviteID
    );

    // 2. Early return if no valid responses
    if (validResponses.length === 0) {
        return (
            <div className={styles.emptyStateWrapper}>
                <div className={styles.emptyState} data-testid='empty-state'>
                    <p className={styles.emptyStateText}>No responses yet. We'll let you know when something comes up!</p>
                </div>
            </div>
        );
    }

    // 3. Sort valid responses
    const responseOrder = {
        [ResponseType.Accept]: 1,
        [ResponseType.Maybe]: 2,
        [ResponseType.NoResponse]: 3,
        [ResponseType.Reject]: 4,
    };

    const sortedResponses = [...validResponses].sort((a, b) => {
        const typeDifference = responseOrder[a.responseType] - responseOrder[b.responseType];

        // Primary sort by response type order
        if (typeDifference !== 0) {
            return typeDifference;
        }

        // Secondary sort by updatedAt (most recent first)
        return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    });

    return (
        <div className={styles.playdateInviteResponseListContainer}>
            {sortedResponses.map((response, index) => (
                <React.Fragment key={`${response.responseID}_${index}`}>
                    <PlaydateInviteResponseUnit inviteResponse={response} data-testid='imbetween-padder' />
                    {index !== sortedResponses.length - 1 && (
                        <div className={styles.inbetweenPadder} data-testid='inbetween-padder'></div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default PlaydateInviteResponseList;